module.exports = __webpack_public_path__ + "static/media/logo.5e25e3a9.png";